export const isDpdLocalDomain = () =>
  window.location.hostname.includes("dpdlocal");
